import React, { Component, PropTypes } from 'react';
import './recent-touchpoint-response-summary.scss';
import { dateUtilities } from '../common';

export class RecentTouchpointResponseSummary extends Component {

  /**
   * View the response details for the item that was clicked.
   * @param {object} e The click event to handle.
   * @param {object} item The summary item to display.
   *
   */
  handleViewClick( e, item ) {
    const { viewResponse } = this.props;
    viewResponse( item );
  }

  /**
   * Format a summary of recent touchpoint responses for display.
   * @param {*} summaryList The items to display.  See TouchpointResponse in the touchpoints reducer for details on this.
   * @param {*} visibleItems Optional.  Defaults to 5.  The number of visible items in the summary.  Any items beyond this number must be accessed via paging or by launching a different window.
   */
  displayTable( summaryList, visibleItems) {
    visibleItems = visibleItems || 5; // 5 is the default number of visible items
    const table = (
      <table id={"recent-touchpoint-response-summary-table"} className="table table-striped">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Form</th>
            <th scope="col">Program</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody id="recent-touchpoint-response-summary-table-body">
          {summaryList.map( (item, idx) => ( idx < visibleItems ?
            <tr scope="row" key={item.formId + '-' + item.id}>
              <td><label htmlFor={dateUtilities.getUserFriendlyFormatFromJson(item.responseCreatedDate)}>{dateUtilities.getUserFriendlyFormatFromJson(item.responseCreatedDate)}</label></td>
              <td>{item.alias != null && item.alias.replace(/ /g, '') !== '' ? item.alias: item.formName}</td>
              <td>{item.programName}</td>
              <td>
                <button className="btn btn-primary" id={ 'button-' + item.formId + '-' + item.id + '-' + idx } onClick={ e => this.handleViewClick(e, item)}>
                  View
                </button>
              </td>
            </tr> : null
          ))}
        </tbody>
      </table>
    );

    const noUpdates = 'No responses';

    return (
      <div>
        {summaryList.length === 0 ? noUpdates : table}
      </div>
    );
  }


  render() {
    const { results, visibleResults } = this.props;

    if (!results) {
      return null;
    }

    if (results.length === 0) {
      return (
        <div className="recent-touchpoint-response-summary">
          <p>
            No recent form responses were found.
          </p>
        </div>
      );
    }

    return (
      <div className="recent-touchpoint-response-summary" id='recent-touchpoint-response-summary-div'>
        {this.displayTable(results, visibleResults)}
      </div>
    );
  }
}

RecentTouchpointResponseSummary.propTypes = {
    results:  PropTypes.any.isRequired,
    visibleResults:  PropTypes.number.isRequired,
    viewResponse: PropTypes.func.isRequired
};

export default RecentTouchpointResponseSummary;



// WEBPACK FOOTER //
// src/touchpoints/recent-touchpoint-response-summary.js